import {Gender, Status, Role} from "../enums/enums";

const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const mobilePattern = /^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/;
const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
const aadhaarPattern = /^[2-9][0-9]{11}$/;
const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export const employeeSchema = () => {
    const role = {...Role};
    delete role.Customer;
    delete role.SuperAdmin;
    delete role.Owner;

    return {
        fName: {
            type: 'text',
            label: 'First name',
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value.trim() === '') return 'First name is required';
                return null;
            },
        },
        lName: {
            type: 'text',
            label: 'Last name',
            columns: {md: 12, lg: 6},
        },
        phone: {
            type: 'text',
            label: 'Mobile',
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value.trim() === '') return 'Mobile is required';
                if (!mobilePattern.test(value)) return "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                return null;
            },
        },
        email: {
            type: 'email',
            label: 'Email',
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (!value) return null;
                if (!emailPattern.test(value)) return 'Invalid email';
                return null;
            },
        },
        password: {
            type: 'password',
            label: 'Password',
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value.trim() === '') return 'Password is required';
                if (!passwordPattern.test(value)) return 'Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character';
                return null;
            },
        },
        role: {
            type: 'select',
            label: 'Role',
            enums: true,
            options: role,
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value.trim() === '') return 'Role is required';
                return null;
            },
        },
        status: {
            type: 'select',
            label: 'Status',
            enums: true,
            options: Status,
            columns: {md: 12, lg: 6},
            validation: (value) => {
                return null;
            },
        },
        customer: {
            type: 'object',
            label: 'Personal Info',
            properties: {
                gender: {
                    type: 'select',
                    label: 'Gender',
                    options: Gender,
                    enums: true,
                    columns: {md: 12, lg: 6},
                    validation: (value) => {
                        if (value.trim() === '') return 'Gender is required';
                        return null;
                    },
                },
                aadhaar: {
                    type: 'text',
                    label: 'Aadhaar no.',
                    columns: {md: 12, lg: 6},
                    validation: (value) => {
                        const val = String(value).trim();
                        if (val === '') return 'Aadhaar is required';
                        if (!aadhaarPattern.test(val)) return 'Invalid Aadhaar';
                        return null;
                    },
                },
                pan: {
                    type: 'text',
                    label: 'Pan no.',
                    columns: {md: 12, lg: 6},
                    validation: (value) => {
                        if (!value) return null;
                        if (!panPattern.test(value)) return 'Invalid Pan';
                        return null;
                    },
                },
                documentUpload: {
                    type: 'file',
                    label: 'Document',
                    columns: {md: 12, lg: 6},
                    isMultiple: true,
                    validation: () => null,
                },
            },
        },
    };
};

export const assignEmployeeSchema = ({list}) => {
    const role = {...Role};
    delete role.Customer;
    delete role.SuperAdmin;
    delete role.Owner;

    const {
        items: internalBranchList,
        status: internalBranchListStatus,
    } = list.internalBranch;

    return {
        role: {
            type: 'select',
            label: 'Role',
            options: role,
            enum: true,
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value === '') return 'Role is required';
                return null;
            },
        },
        branch: {
            type: 'select',
            label: 'Branch',
            options: internalBranchListStatus === "success" ? internalBranchList : {},
            columns: {md: 12, lg: 6},
            validation: (value) => {
                if (value === '') return 'Branch is required';
                return null;
            },
        },
    }
}
